const BASE_URL = '/api/v1';

const handleResponse = async (response) => {
    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.message || 'Something went wrong');
    }
    return data;
};

const post = async (endpoint, body) => {
    try {
        const response = await fetch(`${BASE_URL}${endpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return handleResponse(response);
    } catch (error) {
        throw error;
    }
};

const get = async (endpoint) => {
    try {
        const response = await fetch(`${BASE_URL}${endpoint}`);
        return handleResponse(response);
    } catch (error) {
        throw error;
    }
};

const put = async (endpoint, body) => {
    try {
        const response = await fetch(`${BASE_URL}${endpoint}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return handleResponse(response);
    } catch (error) {
        throw error;
    }
};

const del = async (endpoint) => {
    try {
        const response = await fetch(`${BASE_URL}${endpoint}`, {
            method: 'DELETE',
        });
        return handleResponse(response);
    } catch (error) {
        throw error;
    }
};

export const api = {
    subscribeNewsletter: (data) => {
        // Handle both string (legacy) and object
        const payload = typeof data === 'string' ? { email: data } : data;
        return post('/newsletter', payload);
    },

    submitContactForm: (data) => {
        return post('/contact', data);
    },

    submitFeedbackForm: (data) => {
        return post('/feedback', data);
    },

    joinWaitlist: (data) => {
        // Handle both string (legacy) and object
        const payload = typeof data === 'string' ? { email: data } : data;
        return post('/waitlist', payload);
    },

    // Blog Methods
    getBlogs: (params) => {
        const queryString = new URLSearchParams(params).toString();
        return get(`/blog?${queryString}`);
    },

    getBlog: (id) => {
        return get(`/blog/${id}`);
    },

    createBlog: (data) => {
        return post('/blog', data);
    },

    updateBlog: (id, data) => {
        return put(`/blog/${id}`, data);
    },

    deleteBlog: (id) => {
        return del(`/blog/${id}`);
    }
};
